import React, { CSSProperties, JSX, ReactNode } from "react";
import Util from "../Util";
import Span from "./Span";

type ButtonVariant =
  | "styTempBtn"      // 임시: 파랑
  | "styCompleteBtn"  // 완료: 초록
  | "stySelectBtn"    // 조회
  | "styDeleteBtn"    // 삭제
  | "styExcelBtn"     // 엑셀
  | "styCancelBtn"    // 취소
  | "styCloseBtn"     // 닫기
  | "styInitBtn";     // 초기화

interface ButtonProps {
  variant?: ButtonVariant;

  width?: number;
  height?: number;
  buttonName?: string;
  textEl?: JSX.Element;

  backgroundColor?: string;
  backgroundOnColor?: string;
  borderColor?: string;
  borderOnColor?: string;

  borderRadius?: number;
  buttonClass?: string;
  textClass?: string;
  title?: string;

  fontFamily?: string;
  fontSize?: number;
  fontWeight?: number;
  color?: string;
  onColor?: string;
  letterSpacing?: number;

  onClickFunc?: Function;
  startIcon?: React.ReactNode;
  startOnIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  children?: ReactNode;
  childrenOn?: ReactNode;
  style?: CSSProperties;
}

  /** 색깔 프리셋 */
  const COLOR_PRESET = {
    /* 임시성 */
    styTempBtn: {
      backgroundColor: "#007bff",
      backgroundOnColor: "#0069d9",
      borderColor: "#007bff",
      borderOnColor: "#0069d9",
      color: "#ffffff",
      onColor: "#ffffff",
    },

    /* 완료성 */
    styCompleteBtn: {
      backgroundColor: "#28a745",
      backgroundOnColor: "#218838",
      borderColor: "#28a745",
      borderOnColor: "#218838",
      color: "#ffffff",
      onColor: "#ffffff",
    },

    /* 조회성 */
    stySelectBtn: {
      backgroundColor: "#007bff",
      backgroundOnColor: "#0069d9",
      borderColor: "#007bff",
      borderOnColor: "#0069d9",
      color: "#ffffff",
      onColor: "#ffffff",
    },

    /* 삭제성 */
    styDeleteBtn: {
      backgroundColor: "#dc3545",
      backgroundOnColor: "#c82333",
      borderColor: "#dc3545",
      borderOnColor: "#c82333",
      color: "#ffffff",
      onColor: "#ffffff",
    },

    /* Excel 다운로드 */
    styExcelBtn: {
      backgroundColor: "#6c757d",
      backgroundOnColor: "#5a6268",
      borderColor: "#6c757d",
      borderOnColor: "#5a6268",
      color: "#ffffff",
      onColor: "#ffffff",
    },

    /* 취소 */
    styCancelBtn: {
      backgroundColor: "#6c757d",
      backgroundOnColor: "#5a6268",
      borderColor: "#6c757d",
      borderOnColor: "#5a6268",
      color: "#ffffff",
      onColor: "#ffffff",
    },

    /* 닫기 */
    styCloseBtn: {
      backgroundColor: "#6c757d",
      backgroundOnColor: "#5a6268",
      borderColor: "#6c757d",
      borderOnColor: "#5a6268",
      color: "#ffffff",
      onColor: "#ffffff",
    },

    /* 초기화 */
    styInitBtn: {
      backgroundColor: "#CED4DA",
      backgroundOnColor: "#bfc6cd",
      borderColor: "#CED4DA",
      borderOnColor: "#bfc6cd",
      color: "#212529",
      onColor: "#212529",
    },
  } as const;


const Button = (props: ButtonProps) => {
  const [hoverState, setHoverState] = React.useState<boolean>(false);
  const [focusState, setFocusState] = React.useState<boolean>(false);

  const preset = props.variant ? COLOR_PRESET[props.variant] : undefined;

  const backgroundColor = props.backgroundColor ?? preset?.backgroundColor;
  const backgroundOnColor = props.backgroundOnColor ?? preset?.backgroundOnColor;
  const borderColor = props.borderColor ?? preset?.borderColor;
  const borderOnColor = props.borderOnColor ?? preset?.borderOnColor;
  const color = props.color ?? preset?.color;
  const onColor = props.onColor ?? preset?.onColor;

  return (
    <button
      style={{
        ...props.style,
        width: props.width ? props.width + "px" : "",
        height: props.height ? props.height + "px" : "",
        background:
          (focusState || hoverState) && !props.disabled
            ? (Util.isEmpty(backgroundOnColor) ? backgroundColor : backgroundOnColor)
            : (Util.isEmpty(backgroundColor) ? "transparent" : backgroundColor),
        filter: props.disabled ? "opacity(0.5) drop-shadow(0 0 0 #fff)" : "",
        border: ((focusState || hoverState) && borderOnColor) || borderColor ? "1px solid" : "",
        borderColor:
          (focusState || hoverState) && !props.disabled
            ? (Util.isEmpty(borderOnColor) ? borderColor : borderOnColor)
            : (Util.isEmpty(borderColor) ? "#DDDDDD" : borderColor),
        borderRadius: props.borderRadius ? props.borderRadius + "px" : "",
      }}
      onMouseOver={() => setHoverState(true)}
      onMouseOut={() => setHoverState(false)}
      onFocus={() => setFocusState(true)}
      onBlur={() => setFocusState(false)}
      className={"p0 dpFlx aiC " + (props.buttonClass ? props.buttonClass : "") + (props.disabled ? " csNa" : "")}
      onClick={(e) => {
        e.stopPropagation();
        setHoverState(false);
        if (!props.onClickFunc) return;
        props.onClickFunc(e);
      }}
      disabled={props.disabled}
      title={props.title}
    >
      {hoverState && !props.disabled
        ? (Util.isEmpty(props.startOnIcon) ? props.startIcon : props.startOnIcon)
        : (Util.isEmpty(props.startIcon) ? "" : props.startIcon)}

      {props.buttonName ? (
        <Span
          fontFamily={props.fontFamily}
          fontSize={props.fontSize}
          color={
            (focusState || hoverState) && !props.disabled
              ? (Util.isEmpty(onColor) ? color : onColor)
              : (Util.isEmpty(color) ? "" : color)
          }
          letterSpacing={props.letterSpacing}
          fontWeight={props.fontWeight}
          className={props.textClass}
        >
          {props.buttonName}
        </Span>
      ) : null}

      {props.textEl ? props.textEl : null}
      {props.endIcon}
      {props.childrenOn
        ? ((focusState || hoverState) && !props.disabled ? props.childrenOn : props.children)
        : props.children}
    </button>
  );
};

export default Button;
